import { IWarehouse } from "../../api/warehouses/WarehousesApi";

export class Warehouse {

  public address1?: string;
  public address2?: string;
  public ApplicationId?: string;
  public city?: string;
  public contactEmail?: string;
  public contactName?: string;
  public contactPhone?: string;
  public country?: string;
  public integrationKeyName?: string;
  public maxInventoryCubicMeter?: number;
  public maxInventoryValue?: number;
  public name?: string;
  public postalCode?: string;
  public province?: string;
  public warehouseId?: string;
  public warehouseType?: string;

  public static convertFrom(source: IWarehouse): Warehouse {
    const warehouse = new Warehouse();

    warehouse.address1 = source.Address1;
    warehouse.address2 = source.Address2;
    warehouse.ApplicationId = source.ApplicationId;
    warehouse.city = source.City;
    warehouse.contactEmail = source.ContactEmail;
    warehouse.contactName = source.ContactName;
    warehouse.contactPhone = source.ContactPhone;
    warehouse.country = source.Country;
    warehouse.integrationKeyName = source.IntegrationKeyName;
    warehouse.maxInventoryCubicMeter = source.MaxInventoryCubicMeter;
    warehouse.maxInventoryValue = source.MaxInventoryValue;
    warehouse.name = source.Name;
    warehouse.postalCode = source.PostalCode;
    warehouse.province = source.Province;
    warehouse.warehouseId = source.WarehouseId;
    warehouse.warehouseType = source.WarehouseType;

    return warehouse;
  }
}